(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initDisclosure(details) {
    if (details.dataset.bwiInit === '1') return;
    details.dataset.bwiInit = '1';

    var summary = details.querySelector('summary.bwi__row');
    var panel = details.querySelector('.bwi__panel');
    if (!summary || !panel) return;

    summary.addEventListener('click', function (event) {
      if (REDUCED) return;
      event.preventDefault();
      if (details.dataset.bwiAnimating === '1') return;
      details.dataset.bwiAnimating = '1';

      var target;
      if (details.hasAttribute('open')) {
        panel.style.height = panel.scrollHeight + 'px';
        target = 0;
      } else {
        details.setAttribute('open', '');
        panel.style.height = '0px';
        target = panel.scrollHeight;
      }

      requestAnimationFrame(function () {
        panel.style.height = target + 'px';
      });

      var done = function () {
        panel.removeEventListener('transitionend', done);
        panel.style.height = '';
        if (target === 0) details.removeAttribute('open');
        details.dataset.bwiAnimating = '0';
      };
      panel.addEventListener('transitionend', done);
      window.setTimeout(function () {
        if (details.dataset.bwiAnimating === '1') done();
      }, 400);
    });
  }

  function initRoot(root) {
    root.querySelectorAll('details.bwi__disc').forEach(initDisclosure);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.bwi[data-section-id]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.bwRevReady === '1') return;
      root.dataset.bwRevReady = '1';

      var track = root.querySelector('[data-bw-rev-track]');
      if (!track) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bw-rev-dot]'));
      var prev = root.querySelector('[data-bw-rev-prev]');
      var next = root.querySelector('[data-bw-rev-next]');

      function cards() {
        return Array.prototype.slice.call(track.querySelectorAll('[data-bw-rev-card]'));
      }

      function pitch() {
        var list = cards();
        if (list.length > 1) return list[1].offsetLeft - list[0].offsetLeft;
        if (list.length === 1) return list[0].offsetWidth;
        return track.clientWidth;
      }

      function index() {
        var step = pitch();
        if (!step) return 0;
        var i = Math.round(track.scrollLeft / step);
        var max = cards().length - 1;
        if (i < 0) i = 0;
        if (i > max) i = max;
        return i;
      }

      function paint() {
        var active = index();
        for (var i = 0; i < dots.length; i++) {
          var on = i === active;
          dots[i].classList.toggle('is-active', on);
          if (on) {
            dots[i].setAttribute('aria-current', 'true');
          } else {
            dots[i].removeAttribute('aria-current');
          }
        }
      }

      function goTo(i) {
        var list = cards();
        if (!list.length) return;
        if (i < 0) i = 0;
        if (i > list.length - 1) i = list.length - 1;
        var calm =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: i * pitch(), behavior: calm ? 'auto' : 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          goTo(index() - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          goTo(index() + 1);
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-bw-rev-dot'), 10) || 0);
        });
      });

      var raf = null;
      track.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            paint();
          });
        },
        { passive: true }
      );

      paint();
    }

    function setupAll(scope) {
      var node = scope && scope.querySelectorAll ? scope : document;
      if (node.matches && node.matches('[data-bw-rev]')) setup(node);
      Array.prototype.slice.call(node.querySelectorAll('[data-bw-rev]')).forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setupAll(document);
      });
    } else {
      setupAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      setupAll(event.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dd-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TICK = false;

    function syncOne(root) {
      var el = root.querySelector('.tbl__scroller');
      if (!el) return;
      var scrollable = el.scrollWidth - el.clientWidth > 1;
      if (scrollable) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
      } else {
        el.removeAttribute('tabindex');
        el.removeAttribute('role');
      }
    }

    function syncAll() {
      var roots = document.querySelectorAll('[data-bw-cmptable]');
      for (var i = 0; i < roots.length; i++) syncOne(roots[i]);
    }

    function onResize() {
      if (TICK) return;
      TICK = true;
      window.requestAnimationFrame(function () {
        TICK = false;
        syncAll();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAll);
    } else {
      syncAll();
    }
    window.addEventListener('resize', onResize);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.matches && event.target.matches('[data-bw-cmptable]')
        ? event.target
        : event.target.querySelector('[data-bw-cmptable]');
      if (root) syncOne(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
